import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { get, post } from "../src/utils/http";
// import './config/rem'
import * as echarts from "echarts";
import allTitle from "./components/allTitle.vue";
import VEmojiPicker from "v-emoji-picker";

import loginDialog from "./components/loginDialog.vue";
import lockPrice from "./components/lockPrice.vue";
import lockPriceUser from "./components/lockPriceUser.vue";
import userService from "./components/userService.vue";
import vueSeamlessScroll from "vue-seamless-scroll"; // 循环滚动
import "./utils/dialog-directive";
import VeRing from "v-charts/lib/ring.common"; // 环形图
import VueLazyload from 'vue-lazyload';

// 使用默认配置
// Vue.use(VueLazyload);
Vue.use(VueLazyload,{
    preLoad:1.3,
    error:'dist/xx.png',
    loading:'dist/yy.png',
    attempt:1
})
Vue.use(vueSeamlessScroll);
Vue.use(VEmojiPicker);

Vue.prototype.$echarts = echarts;
Vue.prototype.$img = "https://www.qsou.com";
Vue.prototype.$http = post;
Vue.directive("html-with-spaces", {
	bind(el, binding, vnode) {
		let content = binding.value;
		content = content.replace(/\s+/g, function (match) {
			return Array(match.length + 1).join("&nbsp;");
		});
		el.innerHTML = content;
	}
});
Vue.directive("search", {
	// 只要更新就会触发钩子函数
	update(el, binding) {
		var { searchValue, message } = binding.value;
		// 将字符串转数组
		var arr = message.split(searchValue);
		// console.log(arr, "---arr");

		// 将searchValue标红
		var sp = `<span style="color:red;">${searchValue}</span>`;
		//使用红色的字对数组进行连接，连接后放回到 el中
		el.innerHTML = arr.join(sp);
		// console.log(el.innerHTML, "el.innerHTML");
	}
});
// 在main.js或类似的入口文件中
const EventBus = new Vue();

// 将其挂载到Vue的原型上，以便在任意组件中访问
Vue.prototype.$eventBus = EventBus;

Vue.prototype.$isLogin = function () {
	let userId = window.localStorage.getItem("user_id");
	if (!userId) {
		this.$message.error("请前往登录");
		setTimeout(() => {
			window.location = "/";
		}, 1000);
		return;
	}
};

Vue.component(VeRing.name, VeRing);

import BaiduMap from "vue-baidu-map";
import Video from "video.js";
import "video.js/dist/video-js.css";
import '@/utils/index.scss'
Vue.prototype.$video = Video;
Vue.component("loginDialog", loginDialog);
Vue.component("lockPrice", lockPrice);
Vue.component("lockPriceUser", lockPriceUser);
Vue.component("userService", userService);
Vue.component("allTitle", allTitle);

Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: "5LBIZi1bDkGIveD6vuk9i0GGZGrTGYlj"
});

Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
	beforeCreate() {
		Vue.prototype.$bus = this;
	}
}).$mount("#app");
